// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__PostPurchase .page-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page.BC-Page__PostPurchase .page-title .Polaris-Badge {
  background-color: #C9CCCF;
  padding: 4px 10px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content {
  margin-top: 24px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Notifications {
  margin: 24px 0;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Notifications .Polaris-Banner--statusWarning {
  background-color: #FFF5EA80;
  box-shadow: none;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-Card__Header {
  padding: 8px 20px;
  border-bottom: 1px solid #E1E3E5;
}


.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .Polaris-TextField {
  min-width: 314px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh {
  color: #2C6ECB;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh img {
  width: 24px;
  height: 24px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh.btn-refresh--loading img {
  -webkit-animation: spin 2s linear infinite;
  -moz-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Cell--verticalAlignTop {
  vertical-align: middle;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:first-child,
.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(3) {
  width: 305px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(2) {
  width: 130px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(4) {
  text-align: center;
  width: 132px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell {
  padding: 12px 16px;
  background-color: #FAFBFB;
  border-top: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:first-child {
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  border-color: #E1E3E5;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:last-child {
  border-width: 1px 1px 1px 0px;
  border-style: solid;
  border-color: #E1E3E5;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell {
  padding: 12px 16px;
}


.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-status span {
  color: #616161;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-status .Polaris-Badge--statusSuccess span {
  color: #0C5132;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-id {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-id .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-id .Polaris-Icon .Polaris-Icon__Svg path {
  fill: #8C9196;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-edit .Polaris-Button {
  border: 1px solid #008060;
  color: #008060;
  padding: 5px 10px;
  min-height: 30px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-actions>div {
  display: flex;
  align-items: center;
  height: 30px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-actions .Polaris-Button {
  border: 1px solid #8C9196;
  padding: 4px;
  min-width: 24px;
  min-height: 24px;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .BC-EmptyWidget {
  margin: 2.5rem 0;
  text-align: center;
}

.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .BC-EmptyWidget img {
  width: 45px;
  height: 40px;
  margin-bottom: 0;
}

.BC-Page.BC-Page__PostPurchaseNew .content {
  margin-top: 16px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-title {
  margin-bottom: 8px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-label {
  margin-bottom: 2px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-sub-label {
  margin-bottom: 12px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-sub-label .Polaris-Label__Text {
  color: #6D7175;
}

.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-block-border {
  padding: 16px;
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-block {
  background-color: #F6F6F7;
  padding: 12px;
  border-radius: 6px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .Polaris-Card__Header {
  padding: 24px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .card-body {
  padding: 0 24px 24px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria {
  display: grid;
  grid-template-columns: 48px 240px 1fr;
  gap: 12px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria.form-criteria--all {
  grid-template-columns: 48px 1fr;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria__badge {
  position: relative;
  top: 7.5px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria__badge.form-criteria__badge--if .Polaris-Badge {
  padding: 2px 16px;
  background-color: #FFEA8A;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria__badge.form-criteria__badge--then .Polaris-Badge {
  padding: 2px 10px;
  background-color: #E0F0FF;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  color: #00527C;
  max-width: 48px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria--consequence .form-criteria__type {
  pointer-events: none;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .rule-group-block,
.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .select-collection {
  padding-left: 24px;
  margin-top: 4px;
  margin-bottom: 12px
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .select-collection {
  max-height: 100% !important;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .select-collection>.condition-exclude__block {
  margin-top: 12px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .select-collection>.condition-exclude__block .select-collection {
  margin-top: 4px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .select-tags>div>div {
  padding-left: 24px;
  margin-top: 4px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .product-list {
  background-color: #fff;
  border-radius: 8px;
  border-width: 1px;
  border-style: dashed;
  border-color: #E1E3E5;
  margin-top: 12px;
}

.BC-Page.BC-Page__PostPurchaseNew .content .content-list {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item {
  padding: 8px 16px;
  border-top: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item:first-child {
  border-top: none;
}

.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item::marker {
  content: '';
}

.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item__inner .product-item__info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.post-purchase-visual-editor__style-settings {
  position: relative;
  padding-left: 300px;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel {
  position: fixed;
  height: calc(100% - 56px);
  width: 300px;
  overflow: auto;
  background-color: #fff;
  top: 56px;
  left: 0;
}


.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header {
  padding: 16px;
  box-shadow: 0px -1px 0px 0px #E1E3E5 inset;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 58px;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header .Polaris-Button {
  min-width: 24px;
  min-height: 24px;
  padding: 4px;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header .title {
  font-size: 16px;
  font-weight: 600;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body {
  padding: 8px 16px;
}


.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body li {
  padding: 12px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E1E3E5;
  cursor: pointer;
  font-weight: 600;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body li:hover {
  background: #f6f6f7;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body li .Polaris-Icon {
  margin: 0;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings {
  padding-top: 8px;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-product-block {
  border: 1px dashed #BABFC3;
  background-color: #FAFBFB;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-product-block img {
  background-color: #FAFBFB;
  border: 1px solid #E1E3E5;
  border-radius: 6px;
  padding: 6px 2px;
  width: 48px;
  height: 48px;
  object-fit: cover;
}

.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-product-block .Polaris-Link {
  text-decoration: none;
}


.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-item+.settings-item {
  margin-top: 16px;
}

.post-purchase-visual-editor__style-settings .post-purchase__preview {
  width: calc(100% - 300px);
  background-color: #fff;
  max-width: 900px;
  margin: auto;
  overflow: auto;
}

.post-purchase__preview .post-purchase__preview__header {
  padding: 16px 20px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}


.post-purchase__preview .post-purchase__preview__header .order {
  color: #6D7175;
  font-size: 12px;
}

.post-purchase__preview .post-purchase__preview__header .order-title {
  font-weight: 700;
  font-size: 16px;
  margin-top: 2px;
}

.post-purchase__preview .post-purchase__preview__header .order-view {
  font-weight: 600;
  color: #3573AC;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 2px;
}

.post-purchase__preview .post-purchase__preview__header .order-view .Polaris-Icon {
  width: 16px;
  height: 16px;
  margin: 0;
  position: relative;
  top: 1px;
}

.post-purchase__preview .post-purchase__preview__header .order-view .Polaris-Icon .Polaris-Icon__Svg {
  fill: #3573AC;
}

.post-purchase__preview .post-purchase__preview__body {
  padding-bottom: 20px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown {
  padding: 40px 24px 24px;
  text-align: center;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown .countdown-title {
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 8px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown .countdown-subtitle {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 24px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown .countdown-time {
  font-weight: 500;
  font-size: 16px;
  background-color: #FAFAFA;
  padding: 7px 0;
  min-width: 615px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info {
  display: grid;
  grid-template-columns: 448px 298px;
  gap: 48px;
  padding: 0 48px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .big-thumbnail {
  height: 379px;
  margin: auto;
  margin-bottom: 12px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .post-purchase__preview__thumbnails {
  display: grid;
  grid-template-columns: 100px 100px 100px 100px;
  gap: 12px
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .post-purchase__preview__thumbnails .product-thumbnail {
  cursor: pointer;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .post-purchase__preview__thumbnails .product-thumbnail img {
  max-width: 100%;
  height: 100px;
  object-fit: cover;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-image {
  max-width: 100%;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .slide.selected {
  width: 100%;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .carousel-slider .control-arrow {
  display: none;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .thumbs-wrapper .control-prev::before {
  border-right: 8px solid #000;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .thumbs-wrapper .control-next::before {
  border-left: 8px solid #000;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-price {
  font-weight: 600;
  margin-bottom: 12px;
}
.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-price--discounted {
  font-weight: 600;
  color: #f63257;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-variant-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #D9D9D9;
  margin-bottom: 12px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-variant-wrapper .variant__option--is-focused {
  background-color: #f1f5f9 !important;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-variant-wrapper .variant__option--is-focused.variant__option--is-selected {
  background-color: #e2e8f0 !important;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__detail {
  padding-bottom: 12px;
  border-bottom: 1px solid #D9D9D9;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total {
  margin-bottom: 12px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__detail .product-total__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__detail .product-total__item p {
  color: #595959;
  font-weight: 600;
  font-size: 12px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__item--total {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__item--total p {
  color: #333333;
  font-weight: 600;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-add-cart .Polaris-Button {
  background-color: #3879B5;
  color: #FFFFFF;
  border-radius: 4px;
  padding: 15px 24px;
  width: 100%;
  border: 0;
  margin-bottom: 10px;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-add-cart .Polaris-Button .Polaris-Button__Text {
  font-weight: 600;
  font-size: 12px;

}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-decline .Polaris-Button {
  background-color: #fff;
  color: #3879B5;
  border-radius: 4px;
  padding: 15px 24px;
  width: 100%;
  border: 1px solid #D9D9D9;
}

.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-decline .Polaris-Button .Polaris-Button__Text {
  font-weight: 600;
  font-size: 12px;
}

.BC-PostPurchase-LockCard .Polaris-Card {
  padding: 50px 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/post-purchase.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;;;AAGA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".BC-Page.BC-Page__PostPurchase .page-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page.BC-Page__PostPurchase .page-title .Polaris-Badge {\n  background-color: #C9CCCF;\n  padding: 4px 10px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content {\n  margin-top: 24px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Notifications {\n  margin: 24px 0;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Notifications .Polaris-Banner--statusWarning {\n  background-color: #FFF5EA80;\n  box-shadow: none;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-Card__Header {\n  padding: 8px 20px;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .Polaris-TextField {\n  min-width: 314px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh {\n  color: #2C6ECB;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh img {\n  width: 24px;\n  height: 24px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .search .btn-refresh.btn-refresh--loading img {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Cell--verticalAlignTop {\n  vertical-align: middle;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:first-child,\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(3) {\n  width: 305px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(2) {\n  width: 130px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(4) {\n  text-align: center;\n  width: 132px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell {\n  padding: 12px 16px;\n  background-color: #FAFBFB;\n  border-top: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:first-child {\n  border-width: 1px 0px 1px 1px;\n  border-style: solid;\n  border-color: #E1E3E5;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:last-child {\n  border-width: 1px 1px 1px 0px;\n  border-style: solid;\n  border-color: #E1E3E5;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell {\n  padding: 12px 16px;\n}\n\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-status span {\n  color: #616161;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-status .Polaris-Badge--statusSuccess span {\n  color: #0C5132;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-id {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-id .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .widget-id .Polaris-Icon .Polaris-Icon__Svg path {\n  fill: #8C9196;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-edit .Polaris-Button {\n  border: 1px solid #008060;\n  color: #008060;\n  padding: 5px 10px;\n  min-height: 30px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-actions>div {\n  display: flex;\n  align-items: center;\n  height: 30px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .btn-actions .Polaris-Button {\n  border: 1px solid #8C9196;\n  padding: 4px;\n  min-width: 24px;\n  min-height: 24px;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .BC-EmptyWidget {\n  margin: 2.5rem 0;\n  text-align: center;\n}\n\n.BC-Page.BC-Page__PostPurchase .BC-Page__PostPurchase-Content .BC-EmptyWidget img {\n  width: 45px;\n  height: 40px;\n  margin-bottom: 0;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content {\n  margin-top: 16px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-title {\n  margin-bottom: 8px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-label {\n  margin-bottom: 2px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-sub-label {\n  margin-bottom: 12px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-sub-label .Polaris-Label__Text {\n  color: #6D7175;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-block-border {\n  padding: 16px;\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .card-body .form-block {\n  background-color: #F6F6F7;\n  padding: 12px;\n  border-radius: 6px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .Polaris-Card__Header {\n  padding: 24px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .card-body {\n  padding: 0 24px 24px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria {\n  display: grid;\n  grid-template-columns: 48px 240px 1fr;\n  gap: 12px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria.form-criteria--all {\n  grid-template-columns: 48px 1fr;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria__badge {\n  position: relative;\n  top: 7.5px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria__badge.form-criteria__badge--if .Polaris-Badge {\n  padding: 2px 16px;\n  background-color: #FFEA8A;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria__badge.form-criteria__badge--then .Polaris-Badge {\n  padding: 2px 10px;\n  background-color: #E0F0FF;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 12px;\n  color: #00527C;\n  max-width: 48px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria--consequence .form-criteria__type {\n  pointer-events: none;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .rule-group-block,\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .select-collection {\n  padding-left: 24px;\n  margin-top: 4px;\n  margin-bottom: 12px\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .select-collection {\n  max-height: 100% !important;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .select-collection>.condition-exclude__block {\n  margin-top: 12px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .select-collection>.condition-exclude__block .select-collection {\n  margin-top: 4px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .form-criteria .condition-exclude .condition-exclude__block .select-tags>div>div {\n  padding-left: 24px;\n  margin-top: 4px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .product-list {\n  background-color: #fff;\n  border-radius: 8px;\n  border-width: 1px;\n  border-style: dashed;\n  border-color: #E1E3E5;\n  margin-top: 12px;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .content-list {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item {\n  padding: 8px 16px;\n  border-top: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item:first-child {\n  border-top: none;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item::marker {\n  content: '';\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.BC-Page.BC-Page__PostPurchaseNew .content .content-list .product-item__inner .product-item__info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.post-purchase-visual-editor__style-settings {\n  position: relative;\n  padding-left: 300px;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel {\n  position: fixed;\n  height: calc(100% - 56px);\n  width: 300px;\n  overflow: auto;\n  background-color: #fff;\n  top: 56px;\n  left: 0;\n}\n\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header {\n  padding: 16px;\n  box-shadow: 0px -1px 0px 0px #E1E3E5 inset;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 58px;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header .Polaris-Button {\n  min-width: 24px;\n  min-height: 24px;\n  padding: 4px;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel .post-purchase__left-panel__header .title {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body {\n  padding: 8px 16px;\n}\n\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body li {\n  padding: 12px 6px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #E1E3E5;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body li:hover {\n  background: #f6f6f7;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__body li .Polaris-Icon {\n  margin: 0;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings {\n  padding-top: 8px;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-product-block {\n  border: 1px dashed #BABFC3;\n  background-color: #FAFBFB;\n  padding: 8px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-product-block img {\n  background-color: #FAFBFB;\n  border: 1px solid #E1E3E5;\n  border-radius: 6px;\n  padding: 6px 2px;\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-product-block .Polaris-Link {\n  text-decoration: none;\n}\n\n\n.post-purchase-visual-editor__style-settings .post-purchase__left-panel__product-settings .settings-item+.settings-item {\n  margin-top: 16px;\n}\n\n.post-purchase-visual-editor__style-settings .post-purchase__preview {\n  width: calc(100% - 300px);\n  background-color: #fff;\n  max-width: 900px;\n  margin: auto;\n  overflow: auto;\n}\n\n.post-purchase__preview .post-purchase__preview__header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #D9D9D9;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n\n.post-purchase__preview .post-purchase__preview__header .order {\n  color: #6D7175;\n  font-size: 12px;\n}\n\n.post-purchase__preview .post-purchase__preview__header .order-title {\n  font-weight: 700;\n  font-size: 16px;\n  margin-top: 2px;\n}\n\n.post-purchase__preview .post-purchase__preview__header .order-view {\n  font-weight: 600;\n  color: #3573AC;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-top: 2px;\n}\n\n.post-purchase__preview .post-purchase__preview__header .order-view .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  position: relative;\n  top: 1px;\n}\n\n.post-purchase__preview .post-purchase__preview__header .order-view .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #3573AC;\n}\n\n.post-purchase__preview .post-purchase__preview__body {\n  padding-bottom: 20px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown {\n  padding: 40px 24px 24px;\n  text-align: center;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown .countdown-title {\n  font-weight: 700;\n  font-size: 22px;\n  margin-bottom: 8px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown .countdown-subtitle {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 24px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__countdown .countdown-time {\n  font-weight: 500;\n  font-size: 16px;\n  background-color: #FAFAFA;\n  padding: 7px 0;\n  min-width: 615px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info {\n  display: grid;\n  grid-template-columns: 448px 298px;\n  gap: 48px;\n  padding: 0 48px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .big-thumbnail {\n  height: 379px;\n  margin: auto;\n  margin-bottom: 12px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .post-purchase__preview__thumbnails {\n  display: grid;\n  grid-template-columns: 100px 100px 100px 100px;\n  gap: 12px\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .post-purchase__preview__thumbnails .product-thumbnail {\n  cursor: pointer;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .post-purchase__preview__thumbnails .product-thumbnail img {\n  max-width: 100%;\n  height: 100px;\n  object-fit: cover;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-image {\n  max-width: 100%;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .slide.selected {\n  width: 100%;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .carousel-slider .control-arrow {\n  display: none;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .thumbs-wrapper .control-prev::before {\n  border-right: 8px solid #000;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .thumbs-wrapper .control-next::before {\n  border-left: 8px solid #000;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-title {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-price {\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-price--discounted {\n  font-weight: 600;\n  color: #f63257;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-variant-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #D9D9D9;\n  margin-bottom: 12px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-variant-wrapper .variant__option--is-focused {\n  background-color: #f1f5f9 !important;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-variant-wrapper .variant__option--is-focused.variant__option--is-selected {\n  background-color: #e2e8f0 !important;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__detail {\n  padding-bottom: 12px;\n  border-bottom: 1px solid #D9D9D9;\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total {\n  margin-bottom: 12px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__detail .product-total__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__detail .product-total__item p {\n  color: #595959;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__item--total {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .product-total__item--total p {\n  color: #333333;\n  font-weight: 600;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-add-cart .Polaris-Button {\n  background-color: #3879B5;\n  color: #FFFFFF;\n  border-radius: 4px;\n  padding: 15px 24px;\n  width: 100%;\n  border: 0;\n  margin-bottom: 10px;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-add-cart .Polaris-Button .Polaris-Button__Text {\n  font-weight: 600;\n  font-size: 12px;\n\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-decline .Polaris-Button {\n  background-color: #fff;\n  color: #3879B5;\n  border-radius: 4px;\n  padding: 15px 24px;\n  width: 100%;\n  border: 1px solid #D9D9D9;\n}\n\n.post-purchase__preview .post-purchase__preview__body .post-purchase__preview__info .btn-decline .Polaris-Button .Polaris-Button__Text {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.BC-PostPurchase-LockCard .Polaris-Card {\n  padding: 50px 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
